import usePayment from "../../hooks/usePayment";
import { formatCurrency } from "../../utils/formatCurrency";
import Button from "../../custom/button/button";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { baseUrl } from "../../requests";
import { useSearchParams } from "react-router-dom";


const UndergraduatePayment = () => {
  const { makePayment, isPending } = usePayment();
const [params] = useSearchParams();

const amount = params.get("amount");
const parsedAmount = parseInt(amount!);
const email = params.get("email");
const dataId = params.get("dataId");
const paymentForm = params.get("paymentform");


  const handlePayment = async () => {
    const payload: ProcessPaymentPayload = {
      RouteId: 3,
      MembershipNo: email!,
      Amount:parsedAmount,
      Description: paymentForm!,
      ReturnURL: `${baseUrl}/non-member-events`,
      PaymentForm: paymentForm!,
      DataId: dataId!,
    };
    makePayment(payload, (data) => {
      const responseData = JSON.parse(data?.ResponsePayLoad) as PaymentDetails;
      window.location.href = responseData?.RedirectURL;
    });
  };

  return (
    <section className={classNames("card")}>
      <h2>Pay for Event</h2>
      <div className={styles.line}></div>
      <p>
        You are one step away to complete your event registration. Proceed to
        pay <b>{formatCurrency(parsedAmount)}</b> before the event date.
      </p>
      <br />
      <Button
        isLoading={isPending}
        disabled={isPending}
        onClick={handlePayment}
        type="button"
        text="Make Payment"
      />
    </section>
  );
};

export default UndergraduatePayment;
